import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { IStoreState } from "../../../../reducers/types";
import { actions } from "../../../search/actions";
import { setApplyUserHotelPreferences } from "../../../search/actions/actions";
import {
  getAdultsCount,
  getApplyUserHotelPreferences,
  getChildren,
  getFromDate,
  getLocation,
  getPetsCount,
  getRoomsCount,
  getUntilDate,
} from "../../../search/reducer";
import {
  getTravelWalletCredit,
  getTravelWalletOffers,
} from "../../../travel-wallet/reducer";
import {
  fetchInitialHotelAvailability,
  setAmenitiesFilter,
  setFreeCancelFilter,
  setHotelAvailabilitySortOption,
  setHotelNameFilter,
  setHotelsOnSaleFilter,
  setLifestyleStaysOnly,
  setLoyaltyProgramsFilter,
  setMaxPriceFilter,
  setMealPlanTypeFilter,
  setOpenDatesModal,
  setPolicyFilter,
  setPremiumStaysOnly,
  setStarRatingsFilter,
  setStayTypeFilter,
  setVacationRentalAmenitiesFilter,
  setVacationRentalRoomsAndBedsFilter,
  setViewHotelsNearLocation,
} from "../../actions/actions";
import {
  getHasUserSetHotelPreferences,
  getHotelAvailabilityAmenitiesFilter,
  getHotelAvailabilityCurrency,
  getHotelAvailabilityFreeCancelFilter,
  getHotelAvailabilityHotelNameFilter,
  getHotelAvailabilityHotelsOnSaleFilter,
  getHotelAvailabilityLodgingsHasHomesAndHotels,
  getHotelAvailabilityLodgingsHasMealplans,
  getHotelAvailabilityLoyaltyProgramsFilter,
  getHotelAvailabilityMaxPriceFilter,
  getHotelAvailabilityMealPlanTypeFilter,
  getHotelAvailabilityMinMaxPriceRange,
  getHotelAvailabilityPolicyFilter,
  getHotelAvailabilitySortOption,
  getHotelAvailabilityStarRatingsFilter,
  getHotelAvailabilityStayTypeFilter,
  getHotelAvailabilityVacationRentalAmenitiesFilter,
  getHotelAvailabilityVacationRentalRoomsAndBedsFilter,
  getIsTravelApp,
  getLifestyleStaysLodgingsCount,
  getMapBound,
  getOpenDatesModal,
  getPremiumStaysLodgingsCount,
  getSearchLocationLabel,
  getShowLifestyleStaysOnlyFilter,
  getShowPremiumStaysOnlyFilter,
  getUserHotelPreferences,
  getUserHotelPreferencesCallState,
  getViewHotelsNearLocation,
} from "../../reducer";
import { MobileLocationSelection } from "./component";
import {
  getRewardsAccounts,
  getSelectedAccountReferenceId,
} from "../../../rewards/reducer";

const mapStateToProps = (state: IStoreState) => ({
  searchLocation: getLocation(state),
  locationLabel: getSearchLocationLabel(state),
  fromDate: getFromDate(state),
  untilDate: getUntilDate(state),
  adultsCount: getAdultsCount(state),
  children: getChildren(state),
  roomsCount: getRoomsCount(state),
  petsCount: getPetsCount(state),
  amenities: getHotelAvailabilityAmenitiesFilter(state),
  starRatings: getHotelAvailabilityStarRatingsFilter(state),
  stayTypes: getHotelAvailabilityStayTypeFilter(state),
  mealPlanTypes: getHotelAvailabilityMealPlanTypeFilter(state),
  showPremiumStaysOnly: getShowPremiumStaysOnlyFilter(state),
  showLifestyleStaysOnly: getShowLifestyleStaysOnlyFilter(state),
  maxPrice: getHotelAvailabilityMaxPriceFilter(state),
  minMaxPriceRange: getHotelAvailabilityMinMaxPriceRange(state),
  currency: getHotelAvailabilityCurrency(state),
  hotelName: getHotelAvailabilityHotelNameFilter(state),
  vacationRentalAmenities:
    getHotelAvailabilityVacationRentalAmenitiesFilter(state),
  vacationRentalRoomsAndBeds:
    getHotelAvailabilityVacationRentalRoomsAndBedsFilter(state),
  sortOption: getHotelAvailabilitySortOption(state),
  dateModalOpen: getOpenDatesModal(state),
  hasFreeCancelFilter: getHotelAvailabilityFreeCancelFilter(state),
  hasHotelsOnSaleFilter: getHotelAvailabilityHotelsOnSaleFilter(state),
  isSearchingMap: !!getMapBound(state) || !!getViewHotelsNearLocation(state),
  loyaltyPrograms: getHotelAvailabilityLoyaltyProgramsFilter(state),
  isInPolicy: getHotelAvailabilityPolicyFilter(state),
  shouldApplyUserHotelPreferences: getApplyUserHotelPreferences(state),
  userHotelPreferences: getUserHotelPreferences(state),
  userHotelPreferencesCallState: getUserHotelPreferencesCallState(state),
  hasUserSetHotelPreferences: getHasUserSetHotelPreferences(state),
  premiumStaysLodgingCount: getPremiumStaysLodgingsCount(state),
  lifestyleStaysLodgingCount: getLifestyleStaysLodgingsCount(state),
  walletItemCount: getTravelWalletCredit(state)
    ? getTravelWalletOffers(state).length + 1
    : getTravelWalletOffers(state).length,
  availabilityResultsHasHomesAndHotels:
    getHotelAvailabilityLodgingsHasHomesAndHotels(state),
  availabilityResultsHasMealplans:
    getHotelAvailabilityLodgingsHasMealplans(state),
  isTravelApp: getIsTravelApp(state),
  selectedAccountReferenceId: getSelectedAccountReferenceId(state),
  rewardsAccounts: getRewardsAccounts(state),
});

const mapDispatchToProps = {
  setOccupancyCounts: actions.setOccupancyCounts,
  setRoomsCount: actions.setRoomsCount,
  setPetsCount: actions.setPetsCount,
  setAmenitiesFilter,
  setStarRatingsFilter,
  setPremiumStaysOnly,
  setLifestyleStaysOnly,
  setMaxPriceFilter,
  setHotelNameFilter,
  setFreeCancelFilter,
  setHotelsOnSaleFilter,
  setHotelAvailabilitySortOption,
  setDateModalOpen: setOpenDatesModal,
  setViewHotelsNearLocation,
  fetchInitialHotelAvailability,
  setLoyaltyProgramsFilter,
  setPolicyFilter,
  setApplyUserHotelPreferences,
  setStayTypeFilter,
  setMealPlanTypeFilter,
  setVacationRentalAmenitiesFilter,
  setVacationRentalRoomsAndBedsFilter,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileLocationSelectionConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileLocationSelection = withRouter(
  connector(MobileLocationSelection)
);
